module.exports = Promise.resolve(module.bundle.root("4SSJ7"))